<template>
  <div id="app">
    <header-el></header-el>
    <div class="mb20">
      <div class="search-container" style="width: 100%; height: 300px;">
        <div class="search-mask"></div>
        <img style="height: 300px;object-fit:contain;"  src="/images/projectserchbj.jpg" />
        <div class="search-list">
          <div class="search-part">
            <input
              type="text"
              placeholder="搜索项目……"
              autofocus="autofocus"
              class="search-input"
              v-model="d_searchval"

              v-on:input="searchkeydown"
              v-on:keyup="deletesearchval"
            />
            <input type="submit" value="搜  索"  class="search-btn" v-on:click="searchsubmit()" />
          </div>
          <div class="hot-word">
            <span>热词搜索：</span>
            <!--<a href="javascript:;" v-on:click="projectFilter.Address=null;loadProject()">全部</a>-->

            <a
              href="javascript:;"
              v-on:click="searchvalclick('跑步')"
            >跑步</a>
            <a
              href="javascript:;"
              v-on:click="searchvalclick('瑜伽')"
            >瑜伽</a>
            <a
              href="javascript:;"
              v-on:click="searchvalclick('背包')"
            >背包</a>
            <a
              href="javascript:;"
              v-on:click="searchvalclick('课程')"
            >课程</a>
          </div>
        </div>
      </div>
    </div>
    <div class="project-screen mb30" v-show="d_projectScreenshow">
      <div class="screen-head">
        <ul class="screen-title">
          <li
            :class="globalConfig.selectedCategoryID==category.Value?'screen-active':''"
            v-for="category in categorys"
            v-on:click="listtabval(category.Value)"
            v-bind:key="category.Value"
          >{{category.DisplayName}}</li>
        </ul>
        <div class="screen-button" style="display:none;" v-show="categorysisstart!='isstart'">
          <div class="special-button">
            <div class style="width: 130px;">
              <div class="select-tab" v-on:click="selecttab1" :class="{'select-tab-click':globalConfig.statusIsShow}">
                <span>{{globalConfig.statusText}}</span>
                <span class="status-icon" :class="{'icon-kaistart-direction-up':globalConfig.statusIsShow,'icon-kaistart-direction-down':!globalConfig.statusIsShow}"></span>
              </div>
             <div class="option-tab" style="width: 130px; "  v-show="globalConfig.statusIsShow">
                <ul>

                  <li v-on:click="sortselect1('进行中')">进行中</li>
                  <li v-on:click="sortselect1('已结束')">已结束</li>
                </ul>
              </div>
              <div data-v-042cdcc3="" :class="{'special-cover':globalConfig.sortText=='即将结束'}"></div>
            </div>
            <div class></div>
          </div>
          <div class="special-button">
            <div style="width: 130px;">
              <div class="select-tab" @click="selecttab2" :class="{'select-tab-click':globalConfig.sortIsShow}">
            <span>{{globalConfig.sortText}}</span>
                <span class="status-icon" :class="{'icon-kaistart-direction-up':globalConfig.sortIsShow,'icon-kaistart-direction-down':!globalConfig.sortIsShow}"></span>
              </div>
             <div class="option-tab" style="width: 130px;" v-show="globalConfig.sortIsShow">
                <ul>
                  <li v-on:click="sortselect2('最新上线')">最新上线</li>
                  <li v-on:click="sortselect2('即将结束')">即将结束</li>
                </ul>
              </div>
              <div data-v-042cdcc3="" :class="{'special-cover':globalConfig.statusText=='已结束'}"></div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <ul class="screen-list moreli">
         <productLoading-el v-bind:loadingstart="d_loadingstart" v-bind:loadingempty="d_loadingempty"></productLoading-el>
        <projectBox-el v-for="project in projects.Results" v-bind:key="project.ID" v-bind:project="project"></projectBox-el>
      </ul>

    </div>
    <div class="result-contaniner" v-show="!d_projectScreenshow">
      <div class="result-title">
        <span>搜索结果</span>包含关键词
        <b v-text="d_searprojectchval"></b> 的结果
        <b v-text="projects.TotalCount"></b> 个
      </div>
      <div class="result-subtitle">
        <span class="result-subtitle-btn">项目</span>
      </div>
      <ul class="result-program">
        <projectBox-el v-for="searchproject in projects.Results" v-bind:key="searchproject.ID" v-bind:project="searchproject"></projectBox-el>
      </ul>
      <div class="page-nav clear" v-show="pageData.length>1">

      <ul>
              <li v-show="projects.PageNumber>1"><a @click="pageclickitem(projects.PageNumber-1)"><i class="icon-kaistart icon-kaistart-direction-left" ></i></a></li>
              <li class="cursor"
                    v-for="(item,index) in pageData"
                    v-bind:key="index"
                    v-bind:class="{ active: projects.PageNumber == item,empty:item === '...' }">
                    <a href="javascript:;" style="color:#61616f;" v-if="item === '...'">...</a>
                    <a v-else @click="pageclickitem(item)" >{{item}}</a>
              </li>
              <li v-show="projects.PageNumber!=projects.PageCount"><a @click="pageclickitem(projects.PageNumber+1)"><i class="icon-kaistart icon-kaistart-direction-right" ></i></a></li>
      </ul>

      </div>


      <div class="nomore" v-show="projects.TotalCount==0">
        <p>没有更多项目了...</p>
      </div>
      <!---->
      <!--<div class="result-nav">

      </div>-->
    </div>

    <navshare-el/>
    <footer-el></footer-el>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Header from "../components/header";
import Footer from "../components/footer";
import projectBox from "../components/projectBox";
import productLoading from "../components/productLoading";
import NavShare from "../components/navShare";
export default {
  name: "app",
  components: {
    "header-el": Header,
    "footer-el": Footer,
    "projectBox-el": projectBox,
    "productLoading-el":productLoading,
    "navshare-el":NavShare
  },
  computed: {
    ...mapState({
      projects: state => state.project.projects,
      categorys: state => state.project.categories
    }),
  pageData:function() {
            var i,
            t = this,
            len = 7,
            arr = [1, 2, 3, 4, 5, 6, 7],
            finalArr = [],
            start,
            end,
            pageCount = t.projects.PageCount,
            //pageCount = 10,
            pageNumber = t.projects.PageNumber;

            len =  pageCount < len ? pageCount : len;
            for (i = 0; i < len; i++) {
                finalArr[i] = (i+1);
            }
            if(len < 7){
                return finalArr;
            }
            if(pageNumber < 5){
                finalArr[len - 2] = '...';
                finalArr[len - 1] = pageCount;
            }else{
                if(pageNumber >= pageCount - 3){
                    start = pageCount - 4;
                    end = pageCount;
                    finalArr = [1,'...']
                    for(start; start <= end; start++){
                        finalArr.push(start);
                    }
                }else{
                    start = 3 + (pageNumber - 5);
                    end = 7 + (pageNumber - 5);
                    finalArr = [1,'...']
                    for(start; start <= end; start++){
                        finalArr.push(start);
                    }
                    finalArr.push('...');
                    finalArr.push(pageCount);
                }

            }
            return finalArr;
        }
  },
  data() {
    return {
      projectFilter: {
        Name: { Value: null },
        Pager: { PageNumber: 1, PageSize: 20 },
        CreateTime: { Sort: 1 },
        Category: { Value: 1 },
        Address: { Value: null },
        IsStart:{Value:1},
        Status:{Value:2},
      },
      globalConfig: {
        statusIsShow: false,
        statusText:'项目状态',
        sortIsShow: false,
        sortText:'排序',
        selectedCategoryID:0,

      },
      d_loadingstart:false,
      d_loadingempty:false,
      d_projectScreenshow:true,
      d_searchval:'',
      flag:false,
      categorysisstart:'',
      d_searprojectchval:''
      //分页

    };
  },
  methods: {
    //tab切换
    listtabval:function(val) {
      var t = this
      this.$store.dispatch("project/setprojucts", '{}');

       t.projectFilter={
        Name: { Value: null },
        Pager: { PageNumber: 1, PageSize: 20 },
        Category: { Value: val },
        Address: { Value: null },
        IsStart:{Value:1},
        Status:{Value:2},
        Sort:{Sort:-1},

      }
      if(val==0) {
        t.projectFilter.IsRecommend={Value:true}
      }
      if(val=='isStart') {
        t.projectFilter.IsStart={Value:0}
        t.projectFilter.Category={Value:null}
        t.categorysisstart='isstart'
      }else {
        t.categorysisstart=''
      }
      t.loadProject();
      t.globalConfig.selectedCategoryID=val;
      this.globalConfig.statusText='项目状态';

      this.globalConfig.sortText ='排序';

    },
    //分页点击
    pageclickitem:function(num) {
      var t = this
      t.projectFilter.Pager={
        PageNumber: num,
        PageSize: 20
      }
      t.loadProject()
    },
    //搜索按钮
    searchsubmit:function() {
      var t = this
      if(t.d_searchval=="") {
        return false
      }
      t.loadProject()
      t.d_searprojectchval = t.d_searchval
    },
    //按下搜索输入框
    searchkeydown:function(e) {
      var t = this

      if(!e.target.composing) {
        t.projectFilter ={
           Name: { Value: t.d_searchval },
           Pager: { PageNumber: 1, PageSize: 20 },
           Category: { Value: null },
           Address: { Value: null },
           IsStart:{Value:null},
           Status:{Value:2},
           Sort:{Sort:-1},
        }


        t.loadProject()
      }
      t.d_searprojectchval = t.d_searchval

    },
    //输入框删除
    deletesearchval:function(e) {
      var t = this
      t.projectFilter ={
           Name: { Value: d_searchval },
           Pager: { PageNumber: 1, PageSize: 20 },
           Category: { Value: null },
           Address: { Value: null },
           IsStart:{Value:null},
           Status:{Value:2},
           Sort:{Sort:-1},
        }

      if(t.d_searchval==""){
         return;
       }
       if(e.keyCode==13 || e.key =='Enter') {
        t.loadProject()
      }
      t.d_searprojectchval = t.d_searchval
    },
    //搜索项目关键词
    searchvalclick:function(val) {
      var t = this

      t.projectFilter ={
           Name: { Value: val },
           Pager: { PageNumber: 1, PageSize: 20 },
           Category: { Value: null },
           Address: { Value: null },
           IsStart:{Value:null},
           Status:{Value:2},
           Sort:{Sort:-1},
        }

      t.loadProject()
      t.d_projectScreenshow = false
      t.d_searprojectchval = val
    },
     selecttab1:function(e) {
      e.stopPropagation();
      this.globalConfig.statusIsShow=!this.globalConfig.statusIsShow
      this.globalConfig.sortIsShow = false
    },
    selecttab2:function(e) {
      e.stopPropagation();
      this.globalConfig.sortIsShow=!this.globalConfig.sortIsShow
      this.globalConfig.statusIsShow = false
    },
    sortselect1:function(val) {
    var t = this
    this.$store.dispatch("project/setprojucts", '{}');
     t.projectFilter.Category= { Value: t.globalConfig.selectedCategoryID }

       t.projectFilter.Pager= { PageNumber: 1, PageSize: 20 }
    if(val=='进行中') {

        t.projectFilter.IsStart={Value:1}
          t.projectFilter.IsEnd={Value:0}
      //  t.projectFilter ={
      //      Name: { Value: null },
      //      Pager: { PageNumber: 1, PageSize: 20 },
      //      CreateTime: { Sort: 1 },
      //      Category: { Value: t.globalConfig.selectedCategoryID },
      //      Address: { Value: null },
      //      IsStart:{Value:1},
      //      IsEnd:{Value:0}
      //   }
    }else {

        t.projectFilter.IsStart={Value:null}
          t.projectFilter.IsEnd={Value:1}

      // t.projectFilter ={
      //      Name: { Value: null },
      //      Pager: { PageNumber: 1, PageSize: 20 },
      //      CreateTime: { Sort: 1 },
      //      Category: { Value: t.globalConfig.selectedCategoryID },
      //      Address: { Value: null },
      //      IsStart:{Value:null},
      //      IsEnd:{Value:1}
      //   }
    }

     this.loadProject();
     this.globalConfig.statusIsShow=!this.globalConfig.statusIsShow;
     this.globalConfig.statusText=val;

    },
    sortselect2:function(val) {
      var t = this
      if(val=='最新上线') {
        this.sort('StartTime',-1);
      }else {
        this.sort('EndTime',1);
      }

      this.globalConfig.sortText=val
      this.$store.dispatch("project/setprojucts", '{}');

    },
    loadProject: function() {

      this.d_loadingstart = true

      this.$store.dispatch("project/getProjects", this.projectFilter);
    },
    sort: function(key, value) {
      this.projectList = [];
      if(key=='StartTime') {
        this.projectFilter.EndTime = { Sort: 0 };
      }else {
        this.projectFilter.StartTime = { Sort: 0 };

      }
      this.projectFilter[key] = { Sort: value };
      this.globalConfig.sortIsShow=!this.globalConfig.sortIsShow;
      this.loadProject();
    },
    scrollloadproject: function() {
      // debugger;

      if(!this.d_projectScreenshow) {
        return false;
      }

      if (
        document.documentElement.scrollTop +
          document.documentElement.clientHeight >=
        document.body.scrollHeight-100
      ) {


        if(this.projectFilter.Pager.PageNumber>=this.projects.PageCount || this.projectFilter.Category.Value==0) {
          return false;
        }
        this.projectFilter.Pager.PageNumber += 1;

        this.loadProject();



      }
    }
  },
   watch: {
    projects(val) {
      this.d_loadingstart = false
       if(val.Results && val.Results.length==0) {
        this.d_loadingempty = true
      }else {
        this.d_loadingempty = false
      }
    },
    d_searchval(val) {
      var t = this
      if(val=="") {
         t.d_projectScreenshow = true
         t.projectFilter={
            Name: { Value: null },
            Pager: { PageNumber: 1, PageSize: 20 },

            Status:{Value:2},
            Sort:{Sort:-1},
            Category: { Value: t.globalConfig.selectedCategoryID }
          }

         t.loadProject();
      }else {
         t.d_projectScreenshow = false
      }
    },

  },
  created() {
    this.$store.dispatch("project/getAllCategory");
    //this.$store.dispatch("project/getProjects", this.projectFilter);
  },
  mounted() {
    var t =this
    this.projectFilter = {
       Name: { Value: null },
        Pager: { PageNumber: 1, PageSize: 20 },
        Sort:{Sort:-1},
        Category: { Value: 0 },
        IsRecommend:{Value:true},
        Address:{Value: null },
        IsStart:{Value:1},
        Status:{Value:2},
    }

    this.loadProject();

    window.addEventListener("scroll", this.scrollloadproject);
     document.addEventListener("click",function(){
        if(document.getElementsByClassName("option-tab").length==0) return;
          document.getElementsByClassName("option-tab")[0].style.display="none";
          document.getElementsByClassName("option-tab")[1].style.display="none";
          t.globalConfig.statusIsShow = false
          t.globalConfig.sortIsShow = false
    },false);

  },
  destroyed() {
    //window.removeEventListener("scroll", this.scrollloadproject);
  }
};
</script>


<style>
@import url("../css/projectlist.css");
</style>
